import { vxFormatCount } from '@voxie/frontend-components';
import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { analyticsClient } from '../../../../services';
import { calculateDifference, computeComparisonRange } from '../../../../utils/analytics';

export const useOutboundMessagesTotalMessagesSentByType = createGlobalState(() => {
    const error = ref(false);
    const loading = ref(false);

    const data = ref([]);

    const dataFor = (type) => {
        let values = [];
        if (type) {
            values = data.value.find((group) => group.group_id == type)?.values || [];
        } else {
            values = data.value.reduce((sum, group) => group.values.map((value, index) => sum[index] + value), [0, 0]);
        }

        if (values.length >= 2) {
            return {
                number: values[1],
                percentage: calculateDifference(values),
                label: vxFormatCount(values[1]),
            };
        } else if (values.length === 1) {
            return {
                number: values[0],
                label: vxFormatCount(values[0]),
            };
        }

        return {
            number: 0,
            label: vxFormatCount(0),
        };
    };

    const clearData = () => {
        error.value = false;
        data.value = [];
    };

    const fetchData = ({ startDate, endDate } = {}) => {
        if (loading.value) {
            return;
        }

        const params = {
            range: computeComparisonRange({ start: startDate, end: endDate }),
        };

        clearData();
        loading.value = true;
        analyticsClient
            .outboundMessagesTotalMessagesSentByType(Spark.state.currentTeam.id, params)
            .then((res) => {
                data.value = res.data.data;
            })
            .catch((e) => {
                console.error(e);
                error.value = true;
            })
            .finally(() => {
                loading.value = false;
            });
    };

    return {
        loading,
        error,
        dataFor,
        fetchData,
    };
});
